// removed by extract-text-webpack-plugin
module.exports = {"freshchat-button":"_9SdIL5hmLkhFPFbaxiTtp","loading":"_3wqnszouNhQDjFtu6lrGy-"};


//////////////////
// WEBPACK FOOTER
// ./components/freshchat/freshchat.module.scss
// module id = 119
// module chunks = 0 1 2 3 4 5 6 7 8 9 10